var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"score"},[_vm._v(" 您的完成題數："),_c('span',[_vm._v(_vm._s(_vm.correctNum + _vm.incorrectNum)+"/"+_vm._s(_vm.totalQuestion))]),_vm._v(" 題 ")])}
var staticRenderFns = []

export { render, staticRenderFns }